import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface DebtorDocumentChartProps {
  stats: {
    completeDocuments: number;
    incompleteDocuments: number;
    expiredDocuments: number;
  };
}

export default function DebtorDocumentChart({ stats }: DebtorDocumentChartProps) {
  const documentStatusData = [
    { name: 'Lengkap', value: stats.completeDocuments, color: '#10b981' },
    { name: 'Tidak Lengkap', value: stats.incompleteDocuments, color: '#f59e0b' },
    { name: 'Kadaluarsa', value: stats.expiredDocuments, color: '#ef4444' },
  ].filter(d => d.value > 0);

  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <div className="p-4 border-b">
        <h3 className="text-lg font-semibold">Status Kelengkapan Dokumen</h3>
      </div>
      <div className="p-4">
        {documentStatusData.length > 0 ? (
          <div className="flex items-center gap-6">
            <ResponsiveContainer width="50%" height={200}>
              <PieChart>
                <Pie
                  data={documentStatusData}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={80}
                  paddingAngle={2}
                  dataKey="value"
                >
                  {documentStatusData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
            <div className="space-y-3">
              {documentStatusData.map(item => (
                <div key={item.name} className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: item.color }} />
                  <div>
                    <p className="text-sm font-medium">{item.name}</p>
                    <p className="text-xs text-gray-500">{item.value} debitur</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="h-[200px] flex items-center justify-center text-gray-500">
            Belum ada data debitur
          </div>
        )}
      </div>
    </div>
  );
}
